import { IUserSubData } from './../../models/userData';

import { Component } from '@angular/core';
import { NavController, NavParams, ViewController } from 'ionic-angular';
import { FirebaseService } from '../../services/firebase.service';

@Component({
  selector: 'page-history-payment',
  templateUrl: 'history-payment.html',
})
export class HistoryPaymentPage {

  UserDataSubscriptions: IUserSubData[];
  today;

  constructor(public viewCtrl: ViewController,public navCtrl: NavController, public navParams: NavParams, public fireSrv: FirebaseService) {

    this.today = new Date();

    this.fireSrv.GetUserData().subscribe(res => {
      console.log(res);
      this.UserDataSubscriptions = res;
    });

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad HistoryPaymentPage');
  }

  close(){

    this.viewCtrl.dismiss();
  }



}



// WEBPACK FOOTER //
// ./src/pages/history-payment/history-payment.ts